import _classCallCheck from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import _classPrivateFieldSet from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { log } from './log';
var _instance = /*#__PURE__*/new WeakMap();
var _componentInternalInstance = /*#__PURE__*/new WeakMap();
var _ref = /*#__PURE__*/new WeakMap();
var CommonDialog = /*#__PURE__*/function () {
  function CommonDialog() {
    _classCallCheck(this, CommonDialog);
    _classPrivateFieldInitSpec(this, _instance, null);
    _classPrivateFieldInitSpec(this, _componentInternalInstance, null);
    _classPrivateFieldInitSpec(this, _ref, '');
  }
  return _createClass(CommonDialog, [{
    key: "init",
    value: function init(ref) {
      _classPrivateFieldSet(_instance, this, ref);
    }
  }, {
    key: "initByComponentInstance",
    value: function initByComponentInstance(component, ref) {
      _classPrivateFieldSet(_componentInternalInstance, this, component);
      _classPrivateFieldSet(_ref, this, ref);
    }
  }, {
    key: "open",
    value: function open(data) {
      var _classPrivateFieldGet2;
      if (_classPrivateFieldGet(_instance, this)) {
        _classPrivateFieldGet(_instance, this).value.open(data);
      } else if ((_classPrivateFieldGet2 = _classPrivateFieldGet(_componentInternalInstance, this)) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.refs && _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) {
        var _classPrivateFieldGet3;
        (_classPrivateFieldGet3 = _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.open(data);
      } else {
        log('CommonDialog', '未获取到CommonDialog实例', 'error');
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _classPrivateFieldGet4;
      if (_classPrivateFieldGet(_instance, this)) {
        _classPrivateFieldGet(_instance, this).value.close();
      } else if ((_classPrivateFieldGet4 = _classPrivateFieldGet(_componentInternalInstance, this)) !== null && _classPrivateFieldGet4 !== void 0 && _classPrivateFieldGet4.refs && _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) {
        var _classPrivateFieldGet5;
        (_classPrivateFieldGet5 = _classPrivateFieldGet(_componentInternalInstance, this).refs[_classPrivateFieldGet(_ref, this)]) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.close();
      } else {
        log('CommonDialog', '未获取到CommonDialog实例', 'error');
      }
    }
  }]);
}();
export default CommonDialog;